import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './Components/Navbar';
import FranchiseDashboard from './Franchise/Pages/FranchiseDashboard';
import AddEmployee from './Franchise/Pages/AddEmployee';
import EmployeeList from './Franchise/Pages/EmployeeList';
import DailyAttendance from './Franchise/Pages/DailyAttendance';
import ShiftManagement from './Franchise/Pages/ShiftManagement';
import AttendanceReports from './Franchise/Pages/AttendanceReports';
import SalarySetup from './Franchise/Pages/SalarySetup';
import GenerateSalary from './Franchise/Pages/GenerateSalary';
import Policies from './Franchise/Pages/Policies';
import EmployeeDocs from './Franchise/Pages/EmployeeDocs';
import Departments from './Franchise/Pages/Departments';
import Designations from './Franchise/Pages/Designations';
import RolePermissions from './Franchise/Pages/RolePermissions';
import Login from './Franchise/Pages/Login';
import Companies from './Franchise/Pages/Companies';
import SuperAdminLogin from './Franchise/Pages/SuperAdminLogin';
import EmployeeReport from './Franchise/Pages/EmployeeReport';
import Designation from './Franchise/Pages/Designation';
import LeaveRequest from './Franchise/Pages/LeaveRequest';
import LeaveApproval from './Franchise/Pages/LeaveApproval';
import Franchise from './Franchise/Pages/Franchise';
import Branch from './Franchise/Pages/Branch';
import LeaveType from './Franchise/Pages/leaveType';
import Subscription from './Franchise/Pages/Subscription';
import CustomerSupport from './Support/Cutomer/CustomerSupport';
import AssignTickets from './Support/Company/AssignTickets';
import SupportTickets from './Support/employee/SupportTickets';
import EmployeePerformance from './Support/Company/EmployeePerformance';
import CustomerFeedback from './Support/Cutomer/CustomerFeedback';
import SaveData from './Support/Company/SaveData';
import Dashboard from './Components/Dashboard';

// Protected Route Component
const ProtectedRoute = ({ children, requiredPermission }) => {
  const token = localStorage.getItem("authToken");
  
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // Decode token
  const decodeToken = (token) => {
    try {
      return JSON.parse(atob(token.split(".")[1]));
    } catch (error) {
      return null;
    }
  };

  const decoded = decodeToken(token);

  // If user is a company, give full access
  if (decoded?.role === "company") {
    return children;
  }

  const hasPermission = decoded?.accessPermissions?.includes(requiredPermission);

  return hasPermission ? children : <Navigate to="/dashboard" replace />;
};

// Main App Component with conditional Navbar
function AppContent() {
  const location = useLocation();
  
  // Define routes where Navbar should NOT be shown
  const noNavbarRoutes = ['/', '/login'];
  const showNavbar = !noNavbarRoutes.includes(location.pathname);

  return (
    <div>
      {showNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<SuperAdminLogin />} />
        {/* Protected Routes */}
        <Route path="/franchiseDashboard" element={
          <ProtectedRoute requiredPermission="franchiseDashboard">
            <FranchiseDashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/add-employee" element={
          <ProtectedRoute requiredPermission="add-employee">
            <AddEmployee />
          </ProtectedRoute>
        } />
        
        <Route path="/employee-list" element={
          <ProtectedRoute requiredPermission="employee-list">
            <EmployeeList />
          </ProtectedRoute>
        } />
        
        <Route path="/daily-attendance" element={
          <ProtectedRoute requiredPermission="daily-attendance">
            <DailyAttendance />
          </ProtectedRoute>
        } />
        
        <Route path="/shift-management" element={
          <ProtectedRoute requiredPermission="shift-management">
            <ShiftManagement />
          </ProtectedRoute>
        } />
        
        <Route path="/attendance-reports" element={
          <ProtectedRoute requiredPermission="attendance-reports">
            <AttendanceReports />
          </ProtectedRoute>
        } />
        
        <Route path="/salary-setup" element={
          <ProtectedRoute requiredPermission="salary-setup">
            <SalarySetup />
          </ProtectedRoute>
        } />
        
        <Route path="/generate-salary" element={
          <ProtectedRoute requiredPermission="generate-salary">
            <GenerateSalary />
          </ProtectedRoute>
        } />
        
        <Route path="/policies" element={
          <ProtectedRoute requiredPermission="policies">
            <Policies />
          </ProtectedRoute>
        } />
        
        <Route path="/employee-docs" element={
          <ProtectedRoute requiredPermission="employee-docs">
            <EmployeeDocs />
          </ProtectedRoute>
        } />
        
        <Route path="/departments" element={
          <ProtectedRoute requiredPermission="departments">
            <Departments />
          </ProtectedRoute>
        } />
        
        <Route path="/designations" element={
          <ProtectedRoute requiredPermission="designations">
            <Designations />
          </ProtectedRoute>
        } />
        
        <Route path="/role-permissions" element={
          <ProtectedRoute requiredPermission="role-permissions">
            <RolePermissions />
          </ProtectedRoute>
        } />
        
        <Route path="/login" element={<Login />} />
        
        <Route path="/companies" element={
          <ProtectedRoute requiredPermission="companies">
            <Companies />
          </ProtectedRoute>
        } />
        
        <Route path="/employee-report" element={
          <ProtectedRoute requiredPermission="employee-report">
            <EmployeeReport />
          </ProtectedRoute>
        } />
        
        <Route path="/designation" element={
          <ProtectedRoute requiredPermission="designation">
            <Designation />
          </ProtectedRoute>
        } />
        
        <Route path="/leave-request" element={
          <ProtectedRoute requiredPermission="leave-request">
            <LeaveRequest />
          </ProtectedRoute>
        } />
        
        <Route path="/leave-approval" element={
          <ProtectedRoute requiredPermission="leave-approval">
            <LeaveApproval />
          </ProtectedRoute>
        } />
        
        <Route path="/franchise" element={
          <ProtectedRoute requiredPermission="franchise">
            <Franchise />
          </ProtectedRoute>
        } />
        
        <Route path="/branch" element={
          <ProtectedRoute requiredPermission="branch">
            <Branch />
          </ProtectedRoute>
        } />
        
        <Route path="/leave-type" element={
          <ProtectedRoute requiredPermission="leave-type">
            <LeaveType />
          </ProtectedRoute>
        } />
        
        <Route path="/subscription" element={
          <ProtectedRoute requiredPermission="subscription">
            <Subscription />
          </ProtectedRoute>
        } />

        {/* Customer Support */}
        <Route path="/customer_support" element={
          <ProtectedRoute requiredPermission="customer_support">
            <CustomerSupport />
          </ProtectedRoute>
        } />
        
        <Route path="/com_tickets" element={
          <ProtectedRoute requiredPermission="com_tickets">
            <AssignTickets />
          </ProtectedRoute>
        } />
        
        <Route path="/sup_tickets" element={
          <ProtectedRoute requiredPermission="sup_tickets">
            <SupportTickets />
          </ProtectedRoute>
        } />
        
        <Route path="/employee_performance" element={
          <ProtectedRoute requiredPermission="employee_performance">
            <EmployeePerformance />
          </ProtectedRoute>
        } />

        <Route path="/:ticketId" element={
          <ProtectedRoute requiredPermission="customer-feedback">
            <CustomerFeedback />
          </ProtectedRoute>
        } />

        <Route path="/storedata" element={
          <ProtectedRoute requiredPermission="storedata">
            <SaveData />
          </ProtectedRoute>
        } />

        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
    </div>
  );
}

// Main App Component
function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;